import React, { useMemo } from 'react';
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from 'react-table';
import { FaSort, FaSortUp, FaSortDown } from 'react-icons/fa';
import { Col, Container, Row, Spinner, Table } from 'react-bootstrap';
import './styles.scoped.css';
import { TablePagination } from '../../../components';

function getSortedIcon(isSorted, isSortedDesc) {
  let iconProp = <FaSort />;
  if (isSorted) {
    iconProp = isSortedDesc ? <FaSortDown /> : <FaSortUp />;
  }
  return iconProp;
}

const columnClassName = 'align-middle text-nowrap';
export const deductionRegisterColumns = [
  {
    Header: 'Empl_Name',
    accessor: 'Empl_Name',
    className: columnClassName,
  },
  {
    Header: 'Employee_ID',
    accessor: 'Employee_ID',
    className: columnClassName,
  },
  {
    Header: 'Cleared_Date',
    accessor: 'Cleared_Date',
    className: columnClassName,
  },
  {
    Header: 'Check_ID',
    accessor: 'check_ID',
    className: columnClassName,
  },
  {
    Header: 'Check Date',
    accessor: 'check_Date',
    className: columnClassName,
  },
  {
    Header: 'Net_Wages',
    accessor: 'Net_Wages',
    className: columnClassName,
  },
  {
    Header: 'Void_Flag',
    accessor: 'void_flag',
    className: columnClassName,
    Cell: instance => (instance.value ? 1 : 0),
  },
  {
    Header: 'Void_Date',
    accessor: 'Void_Date',
    className: columnClassName,
  },
  {
    Header: 'Cleared',
    accessor: 'Cleared',
    className: columnClassName,
    Cell: instance => (instance.value ? 1 : 0),
  },
  {
    Header: 'Cleared_Check_Amount',
    accessor: 'Cleared_Check_Amount',
    className: columnClassName,
  },
  {
    Header: 'Out_Check_Amount',
    accessor: 'Out_Check_Amount',
    className: columnClassName,
  },
  {
    Header: 'Direct_Deposit',
    accessor: 'direct_deposit',
    className: columnClassName,
    Cell: instance => (instance.value ? 1 : 0),
  },
];

const CheckReconciliationTable = ({ data, loading }) => {
  const memoData = useMemo(() => data, [data]);

  const tableInstance = useTable(
    {
      columns: deductionRegisterColumns,
      data: memoData,
      initialState: {
        pageSize: 200,
        sortBy: [
          {
            id: 'CreatedAt',
            desc: true,
          },
        ],
      },
    },
    useGlobalFilter,
    useSortBy,
    usePagination,
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
  } = tableInstance;

  const tableHeaders = headerGroups.map(headerGroup => {
    const headers = headerGroup.headers.map(column => (
      <th {...column.getHeaderProps(column.getSortByToggleProps())}>
        {column.render('Header')}
        <span>
          {column.canSort
            ? getSortedIcon(column.isSorted, column.isSortedDesc)
            : null}
        </span>
      </th>
    ));
    return <tr {...headerGroup.getHeaderGroupProps()}>{headers}</tr>;
  });

  const tableRows = page.map(row => {
    prepareRow(row);
    const cells = row.cells.map(cell => (
      <td
        {...cell.getCellProps({
          className: cell.column.className,
          style: cell.column.style,
        })}
      >
        {cell.render('Cell')}
      </td>
    ));

    return <tr {...row.getRowProps()}>{cells}</tr>;
  });

  return (
    <Container fluid>
      <Row className="align-items-center">
        <Col className="d-flex justify-content-center justify-content-md-end">
          <TablePagination tableInstance={tableInstance} />
        </Col>
      </Row>
      <Row>
        <Col className="border border-light rounded shadow-sm">
          <Table hover responsive borderless {...getTableProps()}>
            <thead className="text-nowrap">{tableHeaders}</thead>
            <tbody {...getTableBodyProps()}>{tableRows}</tbody>
          </Table>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {loading && <Spinner animation="border" />}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default CheckReconciliationTable;
